function createIconCache() {
  let cache = {};
  const get = name => cache[name];
  const set = (name, data) => {
    cache[name] = data;
  };
  const reset = () => {
    cache = {};
  };
  return {
    get,
    set,
    reset
  };
}

export { createIconCache };
//# sourceMappingURL=iconCache.js.map
